// -- Split menu -- //
function moveElement(elementSelector, targetSelectors) {
  const element = document.querySelector(elementSelector);
  const footer = document.querySelector("footer");

  if (!element) {
    console.error(`Prvek ${elementSelector} nebyl nalezen`);
    return;
  }

  let moved = false;

  for (const targetSelector of targetSelectors) {
    const target = document.querySelector(targetSelector);
    if (target) {
      target.insertAdjacentElement("afterend", element);
      moved = true;
      break;
    }
  }

  if (!moved && footer) {
    footer.insertAdjacentElement("beforebegin", element);
  }
}

//On funkce, na kliknutí a zavolání funkce
function on(eventType, selector, callback) {
  document.addEventListener(eventType, function (e) {
    let targetElement = e.target;
    while (targetElement && targetElement !== document) {
      if (targetElement.matches(selector)) {
        e.preventDefault();
        callback.call(targetElement, e);
        break;
      }
      targetElement = targetElement.parentElement;
    }
  });
}

const splitMenu = () => {
  const menuWrapper = document.querySelector("#navigation .navigation-in");
  if (menuWrapper) {
    setTimeout(() => {
      let menuItems = menuWrapper.querySelectorAll(
        ".menu-level-1>li:not(.appended-category)"
      );
      let menuHelper = document.querySelector(".menu-helper");
      let menuWrapperStyle = window.getComputedStyle(menuWrapper);
      menuItems.forEach((item) => {
        let offsetRight = item.offsetLeft + item.offsetWidth;
        const itemInHelper =
          item.id === "nav-manufacturers"
            ? menuHelper.querySelector("#nav-manufacturers")
            : menuHelper.querySelector("." + item.classList[0]);
        if (
          offsetRight >
          menuWrapper.clientWidth - parseFloat(menuWrapperStyle.paddingRight)
        ) {
          if (itemInHelper) {
            itemInHelper.classList.remove("splitted");
          }
          item.classList.add("splitted");
        } else {
          if (itemInHelper) {
            itemInHelper.classList.add("splitted");
          }
          item.classList.remove("splitted");
        }
      });
      if (
        menuHelper.querySelector(
          ".menu-level-1 > li:not(.splitted):not(.appended-category)"
        )
      ) {
        menuHelper.classList.remove("empty");
        menuWrapper.classList.remove("fitted");
      } else {
        menuHelper.classList.add("empty");
        menuWrapper.classList.add("fitted");
      }
    }, 200);
  }
};

shoptet.menu.splitMenu = splitMenu;

// CAROUSEL
const handleCarousel = () => {
  const carousel = document.querySelector("#carousel .carousel-inner");
  if (carousel) {
    let observer = new MutationObserver((mutationList) => {
      let currentItem;
      mutationList.forEach((mutation) => {
        if (mutation.target.className === "item active") {
          currentItem = mutation.target;
        }
      });
      if (typeof currentItem == "undefined") return;
      let actualIndex = [
          ...document.querySelectorAll(".carousel-inner .item"),
        ].indexOf(currentItem),
        dotsList = document.querySelectorAll(".carousel-dots li");
      dotsList.forEach((dot) => {
        dot.classList.remove("dot-active");
      });
      dotsList[actualIndex].classList.add("dot-active");
    });
    let dotsCounter = 0,
      dotsList = document.createElement("ul");
    dotsList.classList.add("carousel-dots");
    carousel.querySelectorAll(".item").forEach((item, index) => {
      dotsCounter += 1;
      let dotEl = document.createElement("li");
      dotsList.appendChild(dotEl);
      if (index === 0) dotEl.classList.add("dot-active");
      dotEl.addEventListener("click", (e) => {
        e.preventDefault();
        document
          .querySelector(".carousel-inner .item.active")
          .classList.remove("active");
        let targetItem = document.querySelectorAll(".carousel-inner .item")[
          index
        ];
        const targetItemMedia = targetItem.querySelector("img, video");
        if (targetItemMedia) {
          if (
            targetItemMedia.tagName.toLowerCase() === "img" &&
            !targetItemMedia.src
          ) {
            targetItemMedia.src = targetItemMedia.getAttribute("data-src");
          } else if (targetItemMedia.tagName.toLowerCase() === "video") {
            const sourceElement = targetItemMedia.querySelector("source");
            if (sourceElement && !sourceElement.src) {
              sourceElement.src = sourceElement.getAttribute("data-src");
              targetItemMedia.load(); // Reload the video to apply the new source
            }
          }
        }
        targetItem.classList.add("active");
      });
      observer.observe(item, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
    carousel.appendChild(dotsList);
  }

  // const videoObserver = new IntersectionObserver((entries, observer) => {
  // 	for (const entry of entries) {
  // 		const video = entry.target;
  // 		if (entry.isIntersecting) {
  // 			video.play();
  // 			// Disconnect the observer for this video
  // 			observer.unobserve(video);
  // 		} else {
  // 			video.pause();
  // 		}
  // 	}
  // }, {
  // 	rootMargin: '0px 0px 0px 0px',
  // 	threshold: 0.1 // Adjust threshold as needed
  // });

  // // Select all video elements and observe them
  // document.querySelectorAll('video').forEach((video) => {
  // 	videoObserver.observe(video);
  // });
};
if (shoptetPage == "homepage") {
  handleCarousel();
}

// FLAGS and card
const handleFlags = (product) => {
  const flagsDefault = product.querySelector(".flags-default");
  const flagsExtra = product.querySelector(".flags-extra");

  if (flagsDefault && flagsExtra) {
    flagsDefault.appendChild(flagsExtra);
    flagsDefault.classList.add("contains-extra");
  }
};

const handleTextLayout = (product) => {
  const priceStandard = product.querySelector(".price-standard");
  const prices = product.querySelector(".prices");
  const pDesc = product.querySelector(".p-desc");
  const pInIn = product.querySelector(".p-in-in");
  const availability = product.querySelector(".availability");
  const pricesFinal = product.querySelector(".prices .price-final");

  if (priceStandard && prices) {
    prices.appendChild(priceStandard);
  }
};

const mmAllProducts = document.querySelectorAll(".products-block .product");
if (mmAllProducts.length) {
  mmAllProducts.forEach((product) => handleFlags(product));
  mmAllProducts.forEach((product) => handleTextLayout(product));
}

document.addEventListener("ShoptetDOMContentLoaded", () => {
  const mmAllProducts = document.querySelectorAll(".products-block .product");
  if (mmAllProducts.length) {
    mmAllProducts.forEach((product) => handleFlags(product));
    mmAllProducts.forEach((product) => handleTextLayout(product));
  }
});

window.addEventListener("load", () => {
  setTimeout(() => {
    const mmAllProducts = document.querySelectorAll(".products-block .product");
    if (mmAllProducts.length) {
      mmAllProducts.forEach((product) => handleFlags(product));
      mmAllProducts.forEach((product) => handleTextLayout(product));
    }
  }, 100);
});
// FOOTER-BOTTOM
function footerBilling() {
  const footerBottom = document.querySelector(".footer-bottom");
  const footerGlobal = document.querySelector("#footer");
  if (footerBottom && footerGlobal) {
    const footerBottomWrapper = document.createElement("div");
    footerBottomWrapper.classList.add("footer-bottom-wrapper");
    footerBottomWrapper.appendChild(footerBottom);
    footerGlobal.parentElement.insertBefore(
      footerBottomWrapper,
      footerGlobal.nextElementSibling
    );
    const signature = footerBottom.querySelector("#signature");
    if (signature) {
      signature.style.display = "flex";
      const platebniMetodyEl = document.createElement("img");
      platebniMetodyEl.classList.add("platebni-metody");
      platebniMetodyEl.src =
        "/user/documents/upload/newDesign/platebni-metody.png";
      platebniMetodyEl.alt = "Platební metody";
      signature.parentElement.insertBefore(
        platebniMetodyEl,
        signature.nextElementSibling
      );
    }
  }
}

footerBilling();

// PRODUCT DETAIL
const createShpTabLink = (text, anchor, id) => {
  const shpTabLi = document.createElement("li");
  const shpTabLink = document.createElement("a");
  shpTabLi.classList.add("shp-tab");
  shpTabLi.appendChild(shpTabLink);
  shpTabLink.classList.add("shp-tab-link");
  shpTabLink.href = anchor;
  shpTabLink.innerHTML = text;
  if (id) {
    shpTabLi.id = id;
  }
  return shpTabLi;
};

if (document.body.classList.contains("type-detail")) {
  const pDetailTabs = document.querySelector("#p-detail-tabs");
  const tabContent = document.querySelector("#tab-content");

  const customMobileSlider = document.querySelector(".custom-slider-wrapper");
  setTimeout(() => {
    // console.log(customMobileSlider)
  }, 3000);

  // if (customMobileSlider) {
  // 	$(customMobileSlider).slick({
  // 		infinite: false,
  // 		arrows: false,
  // 		slidesToShow: 1,
  // 		slidesToScroll: 1,
  // 		dots: true,
  // 	})
  // }
  swiperize({
    containers: ".custom-slider-wrapper",
    slide: ".p-main-image",
    customOptions: {
      fullscreen: false,
      infinity: false,
      dots: true,
      arrows: false,
      scrollbar: false,
      lazyPrevNext: true,
    },
    swiperOptions: {
      direction: "horizontal",
      speed: 800,
      spaceBetween: 20,
      slidesPerView: 1,
    },
  }); 
  // DLOUHY POPIS + OSTATNI TABY

  const ratingTab = document.querySelector("#ratingTab");
  if (ratingTab) {
    const ratingTabHeading = document.createElement("h3");
    ratingTabHeading.innerHTML = "Hodnocení";
    ratingTab.prepend(ratingTabHeading);
  }

  const relatedProducts = document.querySelector(".products-related");
  const relatedProductsHeading = document.querySelector(
    ".products-related-header"
  );
  if (relatedProducts && relatedProductsHeading) {
    const relatedText = window.relatedCardsOnProductDetail.find(
      (item) => item.language === shoptetLang
    ).text;
    relatedProductsHeading.innerHTML = relatedText;
    const titleText = relatedProductsHeading.innerText;

    const relatedProductsCount =
      relatedProducts.querySelectorAll(".product").length;
    const tabContent = document.querySelector("#tab-content");
    const relatedProductsLink = createShpTabLink(
      titleText,
      "#relatedProducts",
      "relatedProductsTab"
    );
    // if (pDetailTabs.children[2]) {
    // 	pDetailTabs.insertBefore(relatedProductsLink, pDetailTabs.children[2]);
    // } else {
    pDetailTabs.appendChild(relatedProductsLink);
    // }
    const productContent = document.querySelector("#content");
    relatedProductsHeading.classList.add("homepage-group-title");
    // relatedProductsHeading.innerHTML = `Další produkty z kolekce`
    const relatedProductsTab = document.createElement("div");
    // relatedProductsTab.classList.add('tab-pane')
    relatedProductsTab.id = "relatedProducts";
    relatedProductsTab.appendChild(relatedProductsHeading);
    relatedProductsTab.appendChild(relatedProducts);
    productContent.appendChild(relatedProductsTab);

    const desc = document.querySelector(".basic-description");
    // desc.parentNode.insertBefore(relatedProductsTab, desc.nextSibling)

    const shpTabsWrapper = document.querySelector(".shp-tabs-wrapper");
    const wholeProd = document.querySelector("#relatedProducts");

    if (shpTabsWrapper && wholeProd) {
      let wrapper = document.querySelector("#relatedProductsWrapper");
      if (!wrapper) {
        wrapper = document.createElement("div");
        wrapper.id = "relatedProductsWrapper";
        wholeProd.parentNode.insertBefore(wrapper, wholeProd);
        wrapper.appendChild(wholeProd);
      }
      shpTabsWrapper.parentNode.insertBefore(wrapper, shpTabsWrapper);
    }
    // productContent.appendChild(relatedProductsTab);

    // Find .products-block inside #relatedProducts and change its class
    // const productsBlock = wholeProd.querySelector('.products-block')
    // if (productsBlock) {
    // 	productsBlock.classList.remove('products-block')
    // 	productsBlock.classList.add('products-inline')

    // }

    // const productBlock = wholeProd.querySelector('.products');
    // const allProducts = wholeProd.querySelectorAll('.products .product');
    // allProducts.forEach((product, index) => {
    // 	const img = product.querySelector('img');
    // 	if (img && img.dataset.src) {
    // 		img.src = img.dataset.src;
    // 	}
    // });
    // if (allProducts.length > 4) {
    // 	const showMoreBtn = document.createElement('a');
    // 	showMoreBtn.className = 'btn btn-border';
    // 	showMoreBtn.textContent = 'Zobrazit další';
    // 	showMoreBtn.style.cursor = 'pointer';

    // 	productBlock.appendChild(showMoreBtn); // Changed to append the button at the end of the productBlock

    // 	showMoreBtn.addEventListener('click', function () {
    // 		const inactiveProducts = wholeProd.querySelectorAll('.products .product.inactive');
    // 		inactiveProducts.forEach(product => {
    // 			product.classList.remove('inactive');
    // 			product.classList.add('active');
    // 		});
    // 		this.style.display = 'none';
    // 	});
    // }
    // $(relatedProducts).slick(productsSlickSettings)

    swiperize({
      containers: ".products-related",
      slide: ".product",
      customOptions: {
        fullscreen: false,
        infinity: true,
        dots: true,
        arrows: true,
        scrollbar: false,
        lazyPrevNext: true,
        swiperWrapper: true,
      },
      swiperOptions: {
        direction: "horizontal",
        speed: 800,
        slidesPerView: 1.4,
        spaceBetween: 16,
  
        breakpoints: {
          1300: {
            slidesPerView: 5,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
        },
      },
    });
  }

  const alternativeProductsTabLink = document.querySelector(
    '.shp-tab-link[href="#productsAlternative"]'
  );
  if (alternativeProductsTabLink)
    alternativeProductsTabLink.parentElement.remove();
  const alternativeProducts = document.querySelector("#productsAlternative");
  if (alternativeProducts) {
    alternativeProducts.classList.remove("tab-pane", "fade");
    const alternativeProductsHeading = document.createElement("h2");
    alternativeProductsHeading.classList.add("homepage-group-title");
    const alternativeNadpisy = alternativeNadpis.find(
      (item) => item.language === shoptetLang
    );
    if (alternativeNadpisy) {
      alternativeProductsHeading.innerHTML = alternativeNadpisy.text;
    }
    const productContent = document.querySelector("#content");
    // const helpUSP = document.querySelector('#content > .benefitBanner')
    // if (helpUSP) {
    // 	helpUSP.parentElement.insertBefore(alternativeProductsHeading, helpUSP)
    // 	helpUSP.parentElement.insertBefore(alternativeProducts, helpUSP)
    // } else {

    const holder = document.createElement("div");
    holder.classList.add("holder");
    alternativeProducts.insertBefore(
      alternativeProductsHeading,
      alternativeProducts.firstChild
    );
    productContent.appendChild(alternativeProducts);
    // }
    // $(alternativeProducts.querySelector('.products-block')).slick(productsSlickSettings)

    swiperize({
      containers: ".products-alternative",
      slide: ".product",
      customOptions: {
        fullscreen: false,
        infinity: true,
        dots: true,
        arrows: true,
        scrollbar: false,
        lazyPrevNext: true,
        swiperWrapper: true,
      },
      swiperOptions: {
        direction: "horizontal",
        speed: 800,
        slidesPerView: 1.4,
        spaceBetween: 16,
  
        breakpoints: {
          1300: {
            slidesPerView: 5,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
        },
      },
    });
  }

  const parametersTabContent = document.querySelector(
    "#description .extended-description"
  );

  if (parametersTabContent) {
    const specificationText = window.specificationTabText.find(
      (item) => item.language === shoptetLang
    ).text;
    const parametersTab = createShpTabLink(specificationText, "#parameters");
    const descriptionTab = document.querySelector(
      '.shp-tab[data-testid="tabDescription"]'
    );
    descriptionTab.after(parametersTab);
    parametersTabContent.id = "parameters";
  }

  const shpTabLinks = document.querySelectorAll(".shp-tab-link");
  if (shpTabLinks.length) {
    shpTabLinks.forEach((link) => {
      link.removeAttribute("role");
      link.removeAttribute("data-toggle");

      // Odstranění závorek a čísel z textu odkazu
      link.textContent = link.textContent.replace(/\(\d+\)/g, "").trim();
    });
  }
  const targetNode = document.querySelector(".shp-tabs-row");

  if (targetNode) {
    const config = { childList: true, subtree: true };

    const callback = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          const hiddenLinks = document.querySelector(
            ".shp-tabs-row .hidden-links"
          );
          const shpTabsRow = document.querySelector(".shp-tabs-row .shp-tabs");

          if (hiddenLinks && shpTabsRow) {
            // Přesunout všechny .shp-tab do .shp-tabs-row .shp-tabs
            const shpTabs = hiddenLinks.querySelectorAll(".shp-tab");
            shpTabs.forEach((tab) => {
              shpTabsRow.appendChild(tab);
            });

            // Odstranit .hidden-links
            hiddenLinks.remove();
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    // Přidat posluchače událostí pro resize a orientationchange
    window.addEventListener("resize", () =>
      observer.observe(targetNode, config)
    );
    window.addEventListener("orientationchange", () =>
      observer.observe(targetNode, config)
    );
  }
  window.addEventListener("load", () => {
    setTimeout(() => {
      const mmAllProducts = document.querySelectorAll(
        ".products-block .product"
      );

      if (mmAllProducts.length) {
        mmAllProducts.forEach((product) => handleFlags(product));
        mmAllProducts.forEach((product) => handleTextLayout(product));
        // mmAllProducts.forEach((product) => handleRatings(product))
        // mmAllProducts.forEach((product) => handleProductAvailability(product))
      }
    }, 100);
  });
}

// CART
const handleCart = () => {
  const pageHeader = document.querySelector("#header");
  const cartHeader = document.querySelector(".cart-content .cart-header");
  const cartHeaderHelper = document.querySelector(".cart-header-wrapper");
  const search = document.querySelector(".search");
  const headerTop = document.querySelector(".header-top");
  // console.log(search)
  // console.log(headerTop)
  // if (search && headerTop) {
  // 	headerTop.appendChild(search)
  // }

  // const continueInCart = document.querySelector('.next-step-forward')
  // if (continueInCart) {
  //   const buttonText = window.cartContinueBtn.find(
  //     item => item.language === shoptetLang
  //   )?.text
  //   if (buttonText) {
  //     continueInCart.innerText = buttonText
  //   }
  // }

  if (cartHeader && !cartHeaderHelper) {
    const cartHeaderWrapper = document.createElement("div");
    cartHeaderWrapper.classList.add("cart-header-wrapper");
    cartHeaderWrapper.appendChild(cartHeader);
    cartHeader.classList.add("container");
    pageHeader.parentElement.insertBefore(
      cartHeaderWrapper,
      pageHeader.nextElementSibling
    );
  } else if (cartHeader) {
    cartHeader.remove();
  }
  
  // const discountForm = document.querySelector('.discount-coupon')
  // const summaryWrapper = document.querySelector('.summary-wrapper')
  // if (discountForm && summaryWrapper) {
  // 	summaryWrapper.prepend(discountForm)
  // 	const discountInput = discountForm.querySelector('input')
  // 	discountInput.placeholder = 'Vložte kód'
  // }
  const sidebarCart = document.querySelector(".sidebar-in-cart");
  const backLink = document.querySelector(".back-shopping-link");
  // const sidebarCart = document.querySelector('.sidebar-in-cart .box[data-testid="tableCart"]')
  // const extraDelivery = document.querySelector('.extra.delivery')
  // if (extraDelivery && backLink) {
  // 	if (dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft <= 0)
  // 		extraDelivery.classList.add('free-shipping')
  // 	backLink.appendChild(extraDelivery)
  // 	// sidebarCart.prepend(extraDelivery)
  // }

  const overallWrapper = document.querySelector(".overall-wrapper");
  const cartFooter = document.createElement("div");
  cartFooter.classList.add("cart-footer");
  if (overallWrapper) overallWrapper.appendChild(cartFooter);
  const cartMail = document.querySelector(".contact-box .mail");
  const cartPhone = document.querySelector(".contact-box .tel");

  const sidebarNextStep = document.querySelector("#checkoutSidebar .next-step");
  const orderSummary = document.querySelector("#summary-box");
  if (sidebarNextStep && orderSummary)
    orderSummary.appendChild(sidebarNextStep);

  const nextStep = document.querySelector(".next-step-back");
  if (nextStep) {
    const cartRow = document.querySelector(".cart-inner");
    if (cartRow) {
      cartRow.appendChild(nextStep);
    }
  }

  const sidebarConsents = document.querySelectorAll(
    "#checkoutSidebar .consents"
  );
  const summaryItemPrice = document.querySelector(
    "#checkoutSidebar .order-summary-item.price"
  );
  if (sidebarConsents.length && summaryItemPrice) {
    sidebarConsents.forEach((consent) => {
      summaryItemPrice.parentElement.insertBefore(
        consent,
        summaryItemPrice.nextElementSibling
      );
    });
  }
  if (window.innerWidth <= 1300) {
    const backHolder = document.querySelector(".cart-inner");
    const backHold = document.querySelector(".back-shopping-link");
    if (backHolder && backHold) {
      backHolder.appendChild(backHold);
    }
  }
  // const backToShopButtons = document.querySelectorAll('.back-to-shop')
  // if (backToShopButtons.length) {
  // 	backToShopButtons.forEach((button) => {
  // 		button.innerText = 'ZPĚT K NÁKUPNÍMU KOŠÍKU'
  // 	})
  // }

  // const backToShop = document.querySelector('.back-to-shop')
  // if (backToShop) {
  // 	// console.log(backToShop)
  // 	const backToShopLinks = document.querySelector('.back-shopping-link')
  // 	if (backToShopLinks) {
  // 		// console.log(backToShopLinks)
  // 		backToShopLinks.appendChild(backToShop);
  // 	}
  // }
  const paymentInfoTooltips = document.querySelectorAll(
    ".payment-info .show-tooltip"
  );
  if (paymentInfoTooltips.length) {
    paymentInfoTooltips.forEach((tooltip) => {
      tooltip.innerText = "i";
    });
  }
  const handleFreeRecapitulation = () => {
    setTimeout(() => {
      const recapItemPrices = document.querySelectorAll(
        ".recapitulation-shipping-billing-info > span"
      );
      if (recapItemPrices.length) {
        recapItemPrices.forEach((price) => {
          if (price.innerText.toUpperCase().includes("ZDARMA")) {
            price.classList.add("for-free");
          } else {
            price.classList.remove("for-free");
          }
        });
      }
    }, 100);
  };
  document.addEventListener(
    "ShoptetShippingMethodUpdated",
    handleFreeRecapitulation
  );
  document.addEventListener(
    "ShoptetBillingMethodUpdated",
    handleFreeRecapitulation
  );

  const recapItemPrices = document.querySelectorAll(
    'span[data-testid="recapItemPrice"]'
  );
  if (recapItemPrices.length) {
    recapItemPrices.forEach((price) => {
      if (price.innerText.toUpperCase().includes("ZDARMA")) {
        price.classList.add("for-free");
      } else {
        price.classList.remove("for-free");
      }
    });
  }

  // const continueOrderButton = document.querySelector('#continue-order-button')
  // if (continueOrderButton) {
  //   continueOrderButton.innerText = 'Pokračovat v objednávce' //jazyk
  // }

  // const relatedProductsBuyButton = document.querySelectorAll('.cart-related-product .add-to-cart-button')
  // if (relatedProductsBuyButton.length) {
  // 	relatedProductsBuyButton.forEach((button) => {
  // 		button.innerText = 'Koupit' //jazyk
  // 	})
  // }

  const footerCheck = document.querySelector(".ordering-process-footer");
  if (!footerCheck) {
    const cartProjectMail = document.querySelector(".contact-box .mail");
    const cartProjectPhone = document.querySelector(".contact-box .tel");
    const orderingProcessFooter = document.createElement("footer");
    orderingProcessFooter.classList.add("ordering-process-footer");

    let securePaymentText = "Bezpečná platba";
    let respondTimeText = "Reagujeme do 24 hodin";

    if (shoptetLang === "en") {
      securePaymentText = "Secure Payment";
      respondTimeText = "We respond within 24 hours";
    } else if (shoptetLang === "de") {
      securePaymentText = "Sichere Zahlung";
      respondTimeText = "Wir antworten innerhalb von 24 Stunden";
    }

    orderingProcessFooter.innerHTML = `
  <div class="container">
    <div class="secure-payment">
      <span>${securePaymentText}</span>
      <img src="/user/documents/upload/newDesign/platebni-metody.png" width="286" height="23" alt="Visa, MasterCard, Maestro, PayPal"/>
    </div>
    <div class="contact-box mail-wrapper">
      <span>${respondTimeText}</span> 
    </div>
  </div>
`;
    overallWrapper.appendChild(orderingProcessFooter);
    const orderingProcessFooterPhoneWrapper =
      orderingProcessFooter.querySelector(".phone-wrapper");
    const orderingProcessFooterMailWrapper =
      orderingProcessFooter.querySelector(".mail-wrapper");
    // if (cartProjectPhone) {
    //   const clonedPhone = cartProjectPhone.cloneNode(true);
    //   orderingProcessFooterPhoneWrapper.prepend(clonedPhone);
    //   const phoneElement = orderingProcessFooter.querySelector(
    //     ".phone-wrapper .tel"
    //   );
    //   if (phoneElement) {
    //     phoneElement.classList.add("project-phone");
    //     phoneElement.classList.remove("tel"); // Odstranění třídy 'tel'
    //   }
    // }

    if (cartProjectMail) {
      const clonedMail = cartProjectMail.cloneNode(true);
      orderingProcessFooterMailWrapper.prepend(clonedMail);
      const mailElement = orderingProcessFooter.querySelector(
        ".mail-wrapper .mail a"
      );
      if (mailElement) {
        mailElement.classList.add("project-email");
        mailElement.classList.remove("mail"); // Odstranění třídy 'mail'
      }
    }
  }
  if (shoptetPage === "cart") {
    const productsInCart = document.querySelectorAll(
      '.cart-table tr.removeable[data-micro="cartItem"]'
    );
    productsInCart.forEach((product) => {
      const productSKU = product.getAttribute("data-micro-sku");
      const productName = product.querySelector(".p-name");
      if (productSKU && productName) {
        const productSKUEl = document.createElement("div");
        productSKUEl.classList.add("product-sku");
        productSKUEl.innerHTML = `Kód: ${productSKU}`;
        productName.appendChild(productSKUEl);
      }
    });
  }

  const products = document.querySelectorAll('tbody [data-micro="cartItem"]');
  if (products.length) {
    products.forEach((product) => {
      const pQuantity = product.querySelector(".p-availability ");
      const pName = product.querySelector(".p-name");
      const mainLink = pName.querySelector(".main-link");

      if (pQuantity && pName && mainLink) {
        const quantityHtml = pQuantity.innerHTML;
        mainLink.insertAdjacentHTML(
          "afterend",
          `<div class="availability">${quantityHtml}</div>`
        );
      }
    });
  }

  const cartSummary = document.querySelector(".summary-wrapper");
  if (cartSummary) {
    const box = cartSummary.querySelector(".box");
    const upperSummaryReayl = document.querySelector(".upper-summary");
    if (box) {
      const upperSummary = document.createElement("div");
      upperSummary.classList.add("upper-summary");
      box.prepend(upperSummary);

      const cartContentSummary = document.querySelector(
        ".cart-content .cart-summary"
      );
      if (cartContentSummary) {
        const cartInner = document.querySelector(".cart-inner");
        cartSummary.appendChild(cartContentSummary);

        const h4 = cartContentSummary.querySelector("h4");
        if (h4) {
          h4.innerHTML = extraGiftTitles.find(
            (item) => item.language === shoptetLang
          )?.text;
          if (!cartContentSummary.querySelector(".discount-coupon")) {
            h4.style.display = "none";
          }

          // h4.addEventListener('click', function () {
          // 	this.classList.toggle('active')
          // 	const discountCoupon = cartContentSummary.querySelector('.discount-coupon')
          // 	if (discountCoupon) {
          // 		discountCoupon.classList.toggle('active')
          // 	}
          // })
        }
        if (
          cartContentSummary.querySelector(".discount-coupon .applied-coupon")
        ) {
          const discountCoupon =
            cartContentSummary.querySelector(".discount-coupon");
          h4.classList.add("active");
          discountCoupon.classList.add("active");
        }

        const button = cartContentSummary.querySelector(
          ".discount-coupon button"
        );
        if (button) {
          button.innerHTML = "Uplatnit"; //jazyk
        }
        const freeGift = cartContentSummary.querySelector(".free-gift");
        if (freeGift) {
          const h4Gift = document.createElement("h4");
          h4Gift.innerHTML = "Dárek";
          box.insertBefore(freeGift, upperSummary);
          freeGift.prepend(h4Gift);
        }
      }

      const priceHolder = document.createElement("div");
      priceHolder.classList.add("price-holder");
      upperSummary.appendChild(priceHolder);

      // if (totalSaved > 0) {
      // 	const saveHolder = document.createElement('span');
      // 	saveHolder.classList.add('save-holder');
      // 	const totalSavedActualCurrency = totalSaved.ShoptetFormatAsCurrency();
      // 	saveHolder.innerHTML = `Ušetříte: ${totalSavedActualCurrency}`;
      // 	priceHolder.appendChild(saveHolder);
      // }

      const priceWrapper = cartSummary.querySelector(".price-wrapper");
      if (priceWrapper) {
        priceHolder.appendChild(priceWrapper);
      }

      const shipping = document.querySelector(".extra.delivery");
      if (shipping) {
        // upperSummary.insertAdjacentElement('afterend', shipping)
        // cartSummary.prepend(shipping)
      }
    }
  }
  const nextStepH = document.querySelector(".next-step");
  if (nextStepH) {
    const upperSummary = document.querySelector(".upper-summary");
    if (upperSummary) {
      upperSummary.appendChild(nextStepH);
    }
  }

  if (document.querySelector("body").classList.contains("id--9")) {
    const cartH2 = document.createElement("h2");
    const h2 = document.querySelector(".cart-row .col-md-8 h2");
    if (cartH2 && !h2) {
      cartH2.innerHTML = itemsCartTitle.find(
        (item) => item.language === shoptetLang
      )?.text;
      const row = document.querySelector(".cart-row .col-md-8 .cart-content");
      if (row) {
        row.insertBefore(cartH2, row.firstChild);
      }
    }
  }
  if (document.querySelector("body").classList.contains("id--16")) {
    const deliveryMethods = document.querySelector(".co-delivery-method");
    if (deliveryMethods) {
      const allMethods = deliveryMethods.querySelectorAll(
        "[data-testid='shippingMethod']"
      );
      if (allMethods.length > 6) {
        for (let i = 2; i < allMethods.length; i++) {
          allMethods[i].classList.add("hidden");
        }

        const btnHolder = document.createElement("div");
        btnHolder.className = "btn-holder";

        const showMoreBtn = document.createElement("a");
        showMoreBtn.className = "btn btn-secondary";
        showMoreBtn.textContent = "Zobraziť viac";
        if (shoptetLang === "cz") {
          showMoreBtn.textContent = "Zobrazit více";
        }
        btnHolder.appendChild(showMoreBtn);
        deliveryMethods.appendChild(btnHolder);

        showMoreBtn.addEventListener("click", () => {
          for (let i = 2; i < allMethods.length; i++) {
            allMethods[i].classList.remove("hidden");
          }
          btnHolder.style.display = "none";
        });
      }
      const h4 = deliveryMethods.querySelector("h4");
      if (h4) {
        const h4Text = cartDeliveryTitle.find(
          (item) => item.language === shoptetLang
        ).text;
        if (h4Text) {
          h4.innerHTML = h4Text;
        }
      }
    }
  }
};
if (document.body.classList.contains("ordering-process")) {
  handleCart();
  document.addEventListener("ShoptetDOMCartContentLoaded", handleCart);
}

// POPUP CART
document.addEventListener("ShoptetDOMCartContentLoaded", () => {
  const currencyLabel = dataLayer[0].shoptet.currencyInfo.symbol;
  const cartWidgetProducts = document.querySelectorAll(".cart-widget-product");
  if (cartWidgetProducts.length) {
    cartWidgetProducts.forEach((product) => {
      const productPrice = product.querySelector(
        'span[data-testid="cartWidgetProductPrice"]'
      );
      if (productPrice) {
        const priceEl = document.createElement("div");
        priceEl.classList.add("cart-widget-product-price");
        priceEl.appendChild(productPrice);
        product.appendChild(priceEl);
        const productSKU = product.getAttribute("data-micro-sku");
        if (productSKU) {
          const productSinglePrice = dataLayer[0].shoptet.cart.filter(
            (item) => item.code === productSKU
          )[0].priceWithVat;
          const productSinglePriceEl = document.createElement("div");
          productSinglePriceEl.classList.add(
            "cart-widget-product-single-price"
          );
          productSinglePriceEl.innerHTML = `${productSinglePrice} ${currencyLabel} / ks`; //jazyk
          priceEl.appendChild(productSinglePriceEl);
        }
      }
    });
  }

  let popupCartSummary = document.querySelector(".popup-cart-summary");
  if (!popupCartSummary) {
    popupCartSummary = document.createElement("div");
    popupCartSummary.classList.add("popup-cart-summary");
  }
  let popupCartSummaryPriveVAT = String(
    dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat
  );
  if (popupCartSummaryPriveVAT.includes(".")) {
    popupCartSummaryPriveVAT = popupCartSummaryPriveVAT.replace(".", ",");
  }

  let popupCartSummaryPriceNoVAT = String(
    dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat
  );
  if (popupCartSummaryPriceNoVAT.includes(".")) {
    popupCartSummaryPriceNoVAT = popupCartSummaryPriceNoVAT.replace(".", ",");
  }
  // console.log(popupCartSummaryPriceNoVAT)

  // Převod řetězce na číslo
  let popupCartSummaryPriceNoVATNumber = parseFloat(
    popupCartSummaryPriceNoVAT.replace(",", ".")
  );

  popupCartSummary.innerHTML = `
    <div class="popup-cart-summary-item">
        <strong class="popup-cart-summary-item-label">Celkem za zboží</strong>
        <strong class="popup-cart-summary-item-value">${popupCartSummaryPriveVAT} ${currencyLabel}</strong>
    </div>
    <div class="popup-cart-summary-item">
        <span class="popup-cart-summary-item-label">Celkem bez DPH</span>
        <span class="popup-cart-summary-item-value">${Math.round(
          popupCartSummaryPriceNoVATNumber
        )} ${currencyLabel}</span>
    </div>
`; //jazyk
  const cartWidgetProductsWrapper = document.querySelector(
    ".cart-widget-products"
  );
  if (cartWidgetProductsWrapper)
    cartWidgetProductsWrapper.parentElement.insertBefore(
      popupCartSummary,
      cartWidgetProductsWrapper.nextElementSibling
    );

  const cartWidgetButton = document.querySelector(".cart-widget-button");
  const cartWidgetInner = document.querySelector(".cart-widget-inner");
  if (cartWidgetButton && cartWidgetInner)
    cartWidgetInner.appendChild(cartWidgetButton.cloneNode(true));

  const cartWidgetShipping = document.querySelector(".cart-free-shipping");
  if (cartWidgetShipping) {
    const priceLeftToFreeShipping =
      dataLayer[0].shoptet.cartInfo.leftToFreeShipping.priceLeft;
    if (priceLeftToFreeShipping > 0) {
      const freeShippingBar = document.createElement("div");
      const freeShippingValue = document.createElement("div");
      freeShippingBar.classList.add("price-range");
      freeShippingBar.appendChild(freeShippingValue);

      popupCartSummaryPriveVAT = Number(popupCartSummaryPriveVAT);

      freeShippingValue.style.width = `${
        100 -
        (100 * priceLeftToFreeShipping) /
          (priceLeftToFreeShipping + popupCartSummaryPriveVAT)
      }%`;
      cartWidgetShipping.appendChild(freeShippingBar);
      const shippingWidgetStrongs =
        cartWidgetShipping.querySelectorAll("strong");
      if (shippingWidgetStrongs.length) {
        shippingWidgetStrongs.forEach((strong) => {
          if (strong.innerText.includes("ZDARMA"))
            strong.classList.add("free-shipping-strong"); //jazyk
        });
      }
    }
  }
});
// document.addEventListener('ShoptetCartUpdated', () => {
// 	const popupCartSummary = document.querySelector('.popup-cart-summary')
// 	console.log(popupCartSummary)
// 	// const popupCartSummaryPriveVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat
// 	// const popupCartSummaryPriceNoVAT = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withoutVat
// 	// const popupCartPriceVAT = popupCartSummary.querySelector('strong.popup-cart-summary-item-value')
// 	// const popupCartPriceNoVAT = popupCartSummary.querySelector('span.popup-cart-summary-item-value')
// 	// popupCartPriceVAT.innerHTML = `${popupCartSummaryPriveVAT} ${currencyLabel}`
// 	// popupCartPriceNoVAT.innerHTML = `${Math.round(popupCartSummaryPriceNoVAT)} ${currencyLabel}`
// })

// ADVANCED ORDER
document.addEventListener("ShoptetDOMAdvancedOrderLoaded", () => {
  const advancedOrder = document.querySelector(".advanced-order");
  const aoTop = document.createElement("div");
  aoTop.classList.add("ao-top");
  advancedOrder.prepend(aoTop);
  const aoTitle = advancedOrder.querySelector(".h1");
  if (aoTitle) aoTop.appendChild(aoTitle);
  const aoProduct =
    advancedOrder.querySelector(".ao-product") ||
    advancedOrder.querySelector(".h2");
  if (aoProduct) aoTop.appendChild(aoProduct);
  const cboxClose = document.querySelector("#cboxClose");
  if (cboxClose) {
    cboxClose.innerText = "Zavřít"; //jazyk
    cboxClose.id = "cboxClose";
    cboxClose.classList.add("close");
    // aoTop.appendChild(cboxClose)
  }
  const continueShoppingBtn = document.createElement("button");
  continueShoppingBtn.classList.add("btn", "black-border");
  continueShoppingBtn.innerText = "Zavřít"; //jazyk
  continueShoppingBtn.addEventListener("click", () => {
    shoptet.modal.close();
  });
  const extraStep = advancedOrder.querySelector(".extra.step");
  if (extraStep) extraStep.prepend(continueShoppingBtn);

  const deliveryStrongs = advancedOrder.querySelectorAll(
    ".extra.delivery strong"
  );
  if (deliveryStrongs.length) {
    deliveryStrongs.forEach((strong) => {
      if (strong.innerText === "ZDARMA") strong.classList.add("for-free"); //jazyk
    });
  }
  const suggestion = advancedOrder.querySelector(".advanced-order-suggestion");
  if (suggestion) {
    suggestion.innerHTML = "Můžete ještě přidat ...";
  }
  const img = advancedOrder.querySelector(".ao-product .ao-image img");
  if (img) {
    img.src = img.getAttribute("data-src");
  }

  const advancedOrderProducts = $(".colorbox-html-content #products");
  if (advancedOrderProducts.length) {
    advancedOrderProducts.slick(productsSlickSettings);
  }
});

// EMPTY CART

const handleEmptyCart = () => {
  const emptyCart = document.querySelector(".cart-inner.cart-empty");
  if (!emptyCart) return;
  document.body.classList.add("custom-empty-cart");
  const cartHeading = emptyCart.querySelector(".cart-heading");
  const cartText = document.createElement("p");
  cartText.classList.add("narrow-custom", "text-center");
  const prazdnyKosikPerexText = window.prazdnyKosikPerex.find(
    (item) => item.language === shoptetLang
  ).text;
  cartText.innerText = prazdnyKosikPerexText;
  if (cartHeading) {
    const prazdnyKosikNadpisText = window.prazdnyKosikNadpis.find(
      (item) => item.language === shoptetLang
    ).text;
    cartHeading.innerText = prazdnyKosikNadpisText;
    cartHeading.classList.add("homepage-group-title");
    cartHeading.parentElement.insertBefore(
      cartText,
      cartHeading.nextElementSibling
    );
  }
  const cartEmail = emptyCart.querySelector(".mail");
  const cartPhone = emptyCart.querySelector(".tel");
  const cartContact = document.createElement("ul");
  cartContact.classList.add("cart-contact", "contact-box");
  if (cartPhone) {
    cartContact.appendChild(cartPhone.parentElement);
  }
  if (cartEmail) {
    const emailPerexText = window.emailPerexText.find(
      (item) => item.language === shoptetLang
    ).text;
    const emailPerex = document.createElement("span");
    emailPerex.innerText = emailPerexText;
    cartEmail.parentElement.insertBefore(
      emailPerex,
      cartEmail.nextElementSibling
    );
    cartContact.appendChild(cartEmail.parentElement);
  }
  emptyCart.appendChild(cartContact);

  // Přidání btn holder s dvěma odkazy
  const btnHolder = document.createElement("div");
  btnHolder.classList.add("btn-holder", "text-center");

  const primaryButton = window.primaryButtonText.find(
    (item) => item.language === shoptetLang
  );
  const secondaryButton = window.secondaryButtonText.find(
    (item) => item.language === shoptetLang
  );

  btnHolder.innerHTML = `
        <a href="${primaryButton.url}" class="btn btn-primary">${primaryButton.text}</a>
        <a href="${secondaryButton.url}" class="btn secondary">${secondaryButton.text}</a>
    `;

  emptyCart.appendChild(btnHolder);

  const emptyCartHeader = document.querySelector(".cart-header-wrapper");
  if (emptyCartHeader) emptyCartHeader.remove();
};

const emptyCart = document.querySelector(".cart-inner.cart-empty");
if (emptyCart) handleEmptyCart();

document.addEventListener("ShoptetDOMCartContentLoaded", () => {
  if (!dataLayer[0].shoptet.cart.length) handleEmptyCart();
});

window.addEventListener("beforeunload", function (event) {
  window.sessionStorage.removeItem("openedFilters");
});

// const backToTop = document.querySelector('#back-to-top')
// if (backToTop) {
// 	backToTop.addEventListener('click', (e) => {
// 		e.preventDefault()
// 		window.scrollTo(0, 0)
// 	})
// }

const handleFooter = async () => {
  // const socialIcons = document.querySelector('.footer-links-icons')
  // const contactBanner = document.querySelector('.custom-footer__contact')
  // if (socialIcons && contactBanner) contactBanner.appendChild(socialIcons)
  const cookies = document.querySelector(".js-cookies-settings");
  if (cookies) {
  }
  const signature = document.querySelector("#signature");
  if (signature) {
    const mirandaMediaLink = `
    <span>Created by </span>
			<a class="company" href="https://www.mirandamedia.cz/shoptetnamiru" target="_blank">
				<img class="company__logo" src="/user/documents/upload/newDesign/miranda.svg">
				MirandaMedia Group s.r.o.
			</a>
      <span> on the platform </span>
		`;
    signature.insertAdjacentHTML("beforeend", mirandaMediaLink);

    const title = signature.querySelector(".title");
    if (title) {
      title.innerText = "Shoptet";
    }
  }
  const footerHeadings = document.querySelectorAll(
    ".banner-wrapper > span > h4"
  );
  footerHeadings.forEach((heading) => {
    heading.classList.add("clickable");
    heading.addEventListener("click", () => {
      heading.closest(".banner-wrapper").classList.toggle("active");
    });
  });
  const footerCategories = document.querySelector(
    ".custom-footer__categories > h4"
  );
  if (footerCategories) {
    footerCategories.classList.add("clickable");
    footerCategories.addEventListener("click", () => {
      footerCategories
        .closest(".custom-footer__categories")
        .classList.toggle("active");
    });
  }

  const siteName = document.querySelector("#footer .site-name");
  const customFooter = document.querySelector(
    "#footer .custom-footer__banner1 .socials"
  );
  if (customFooter) {
    customFooter.insertBefore(siteName, customFooter.firstChild);
  }
  const customFooterContact = document.querySelector(
    "#footer .custom-footer__contact"
  );
  const customFooterContactPlaceholder = document.querySelector(
    "#footer .contacts-placeholder"
  );
  if (customFooterContact && customFooterContactPlaceholder) {
    customFooterContactPlaceholder.append(customFooterContact);
  }

  // const footeSiteNameImg = document.querySelector('#footer .site-name img')
  // if (footeSiteNameImg) {
  // 	footeSiteNameImg.src = '/user/documents/upload/miranda/logo-footer.svg'
  // }
  // const socialBanner = document.querySelector('.social-wrapper')
  // if (socialBanner) {
  // 	siteName.appendChild(socialBanner)
  // }
  const footer = document.querySelector("#footer");
  const instagram = document.querySelector(".custom-footer__instagram ");

  const benefitsWrapper = document.querySelector(".benefitBanner");
  if (benefitsWrapper) {
    footer.insertAdjacentElement("beforebegin", benefitsWrapper);
  }
  if (instagram) {
    const h4 = instagram.querySelector("h4");
    const text = instagramTitle.find(
      (item) => item.language === shoptetLang
    )?.text;
    if (h4 && text) h4.innerHTML = text;
    footer.insertAdjacentElement("beforebegin", instagram);
  }


  const customFooter2 = document.querySelector(".custom-footer");
  if (customFooter2) {
    // Vytvoření tlačítka "Scroll to Top"
    const scrollToTopBtn = document.createElement("a");
    scrollToTopBtn.classList.add("scroll-to-top");
    scrollToTopBtn.href = "#";

    // Přidání tlačítka do .custom-footer
    customFooter2.appendChild(scrollToTopBtn);

    // Přidání event listeneru pro scrollování nahoru
    scrollToTopBtn.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
};
handleFooter();

// const shoptetPage = dataLayer[0].shoptet.pageType
// const shoptetLang = dataLayer[0].shoptet.language

// const handleUSP = () => {
// 	const benefitBanner = document.querySelector('.benefitBanner')
// 	if (benefitBanner) {
// 		if (dataLayer[0].shoptet.pageType === 'homepage') {
// 			const firstProductsBlock = document.querySelectorAll('.products-block')
// 			if (firstProductsBlock.length)
// 				firstProductsBlock[0].parentElement.insertBefore(benefitBanner, firstProductsBlock[0].nextElementSibling)
// 		}
// 	}
// }
// handleUSP()

// const handleHomepageProducts = async () => {
// 	const productBlocks = document.querySelectorAll('.products-block');
// 	if (productBlocks.length > 0) {
// 		$(productBlocks[0]).slick(productsSlickSettings);
// 	}

// }
if (shoptetPage === "homepage") {
  const productsSelectors = () => {
    const allProducts = document.querySelectorAll(".products");

    if (!allProducts) return;

    const productsIDs = [];

    for (const products of allProducts) {
      // if (index === 0) continue;

      productsIDs.push(`#${products.id}`);
    }
    // console.log(productsIDs)
    return productsIDs;
  };

  swiperize({
    containers: [...productsSelectors()],
    slide: [swiperize.spreadClass(productsSelectors(), ".product")],
    customOptions: {
      fullscreen: false,
      infinity: true,
      dots: true,
      arrows: true,
      scrollbar: false,
      lazyPrevNext: true,
    },
    swiperOptions: {
      direction: "horizontal",
      speed: 800,
      slidesPerView: 1.4,
      spaceBetween: 16,

      breakpoints: {
        1300: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
      },
    },
  });

  function homePageSections() {
    let headingElements = document.querySelectorAll(".homepage-group-title");
    let insertAfterElement = document.querySelector(".before-carousel");

    if (document.querySelector("body").classList.contains("mobile")) {
      insertAfterElement = document.querySelector(".banners-row");
    }

    headingElements.forEach((heading, index) => {
      let splitClass = heading.className.split("homepage-products-heading-");
      if (splitClass.length > 1) {
        let headingNumber = splitClass[1].split(" ")[0];
        let productElement = document.querySelector(
          `.homepage-products-${headingNumber}`
        );

        if (productElement) {
          const section = document.createElement("section");
          section.classList.add(
            "product-section",
            `product-section-${headingNumber}`
          );

          // Přidání třídy rolex-products, pokud je titulek Rolex
          if (heading.textContent.trim() === "Rolex") {
            section.classList.add("rolex-products");
          }

          const container = document.createElement("div");
          container.classList.add("container");

          section.appendChild(container);
          container.appendChild(heading);
          container.appendChild(productElement);

          if (insertAfterElement) {
            insertAfterElement.insertAdjacentElement("afterend", section);
            insertAfterElement = section; // Aktualizujeme insertAfterElement na nově vloženou sekci
          }
        }
      }
    });
  }
  homePageSections();

  const safe = document.querySelector(".safe-packaging");
  console.log(safe);
  moveElement(".safe-packaging", [
    ".product-section:last-of-type",
    ".before-carousel",
  ]);
  moveElement(".about-us", [".shop-review", ".body-banners"]);
}

function addEmptySlides(selector, rules) {
  const swiperWrapper = document.querySelector(`${selector} .swiper-wrapper`);
  if (swiperWrapper) {
    rules.sort((a, b) => b.width - a.width);
    const applicableRule = rules.find((rule) => window.innerWidth > rule.width);

    if (applicableRule) {
      for (let i = 0; i < applicableRule.emptySlidesCount; i++) {
        const emptySlide = document.createElement("div");
        emptySlide.classList.add("swiper-slide");
        swiperWrapper.appendChild(emptySlide);
      }
    }
  }
}

// ANIMACE
let target = document.querySelectorAll(".products-block");
const target2 = document.querySelector(".top-categories-grid");
function handleIntersection(entries) {
  entries.map((entry, index) => {
    entry.target.style.removeProperty("--animation-delay");
    entry.target.setAttribute(
      "style",
      entry.target.getAttribute("style")
        ? entry.target.getAttribute("style") + `--animation-delay: ${index}`
        : `--animation-delay: ${index}`
    );
    // entry.target.setAttribute('animation-delay', `${index}`)
    if (entry.isIntersecting) {
      entry.target.classList.add("visible");
    }
  });
}
const observer = new IntersectionObserver(handleIntersection);
const observer2 = new IntersectionObserver(handleIntersection);
if (target.length) {
  target.forEach((item) => {
    item.classList.add("animation");
    const subtargets = item.querySelectorAll(".product");
    subtargets.forEach((subtarget) => {
      observer.observe(subtarget);
    });
  });
}
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", () => {
  if (target.length) {
    target.forEach((item) => {
      item.classList.add("animation");
      const subtargets = item.querySelectorAll(".product");
      subtargets.forEach((subtarget) => {
        observer.observe(subtarget);
      });
    });
  }
});
if (target2) {
  target2.classList.add("animation");
  const subtargets = target2.querySelectorAll(".category");
  subtargets.forEach((subtarget) => {
    observer2.observe(subtarget);
  });
}

// const handleCustomDetail = () => {
// 	// Najít .basic-description a obalit obsah divem .content-wrapper
// 	const basicDescription = document.querySelector('.basic-description')
// 	if (basicDescription) {
// 		const contentWrapper = document.createElement('div')
// 		contentWrapper.classList.add('content-wrapper')

// 		while (basicDescription.firstChild) {
// 			contentWrapper.appendChild(basicDescription.firstChild)
// 		}

// 		// Najít předposlední .p-thumbnail img a vytvořit img element
// 		const thumbnails = document.querySelectorAll('.p-thumbnail img')
// 		if (thumbnails.length) {
// 			const img = document.createElement('img')
// 			const imgSrc = thumbnails[thumbnails.length - 2].getAttribute('data-src')
// 			const origSrc = imgSrc.replace('/related/', '/orig/')
// 			img.src = origSrc
// 			img.classList.add('side-detail-img')
// 			basicDescription.appendChild(img)
// 		}

// 		basicDescription.appendChild(contentWrapper)
// 	}

// 	// Najít .extended-description .detail-parameters a přidat třídu .content-wrapper

// 	const detailParameters = document.querySelector('.extended-description')
// 	if (detailParameters) {
// 		const contentWrapper = document.createElement('div')
// 		contentWrapper.classList.add('content-wrapper')

// 		while (detailParameters.firstChild) {
// 			contentWrapper.appendChild(detailParameters.firstChild)
// 		}

// 		// Najít první h3 a přepsat jeho innerHTML
// 		const firstH3 = detailParameters.querySelector('h3')
// 		if (firstH3) {
// 			const specificationText = window.specificationTabText.find(
// 				item => item.language === shoptetLang
// 			).text
// 			firstH3.innerHTML = specificationText
// 		}

// 		// Najít poslední .p-thumbnail img a vytvořit img element
// 		const thumbnails = document.querySelectorAll('.p-thumbnail img')
// 		if (thumbnails.length) {
// 			const img = document.createElement('img')
// 			const imgSrc = thumbnails[thumbnails.length - 1].getAttribute('data-src')
// 			const origSrc = imgSrc.replace('/related/', '/orig/')
// 			img.src = origSrc
// 			img.classList.add('side-detail-img')
// 			detailParameters.appendChild(img)
// 		}

// 		detailParameters.appendChild(contentWrapper)
// 	}
// 	const firstH3 = document.querySelector('.extended-description h3')
// 	if (firstH3) {
// 		const specificationText = window.specificationTabText.find(
// 			item => item.language === shoptetLang
// 		).text
// 		firstH3.innerHTML = specificationText
// 	}
// 	const productVideos = document.querySelector('#productVideos')
// 	if (productVideos) {
// 		const videoText = basicDescription.querySelector('.video-popis')
// 		const heading = productVideos.querySelector('h3') // Předpokládám, že nadpis je h3, upravte podle potřeby
// 		const iframe = productVideos.querySelector('iframe')
// 		if (iframe) {
// 			iframe.classList.add('side-detail-img')
// 		}
// 		if (heading) {
// 			const contentWrapper = document.createElement('div')
// 			contentWrapper.classList.add('content-wrapper')

// 			contentWrapper.appendChild(heading)

// 			if (videoText) {
// 				contentWrapper.appendChild(videoText)
// 			}

// 			productVideos.insertBefore(contentWrapper, productVideos.firstChild)
// 		}
// 	}
// }

// if (shoptetPage === 'productDetail') handleCustomDetail()

if (window.innerWidth < 768) {
  const topNavigationBarMenu = document.querySelector(
    ".top-navigation-bar-menu"
  );
  const navigationIn = document.querySelector("#navigation .navigation-in");

  if (topNavigationBarMenu && navigationIn) {
    navigationIn.appendChild(topNavigationBarMenu);
  }
}

function smoothScrollTo(target, offset = -150, duration = 700) {
  const targetElement = document.querySelector(target);
  if (targetElement) {
    const targetPosition =
      targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });
  }
}

// Přidání event listeneru pomocí vaší funkce `on`
on("click", ".shp-tab-link", function (e) {
  const target = this.getAttribute("href");
  if (document.querySelector(target)) {
    smoothScrollTo(target, 200);
  }
});

// const handleNewsletter = () => {
//   const newsLeter = document.querySelector('.custom-footer__newsletter')
//   if (newsLeter) {
//     const btn = newsLeter.querySelector('button')
//     const header = newsLeter.querySelector('.newsletter-header')
//     const title = header.querySelector('h4')
//     const perex = document.createElement('p')
//     // if (perex && header) {
//     // 	header.appendChild(perex);
//     // 	if (newsLetterPerex) {
//     // 		const perexText = newsLetterPerex.find((item) => item.language === shoptetLang).text;
//     // 		perex.innerText = perexText;
//     // 	}
//     // }
//     // if (btn && newsLetterBtn) {
//     // 	const btnText = newsLetterBtn.find((item) => item.language === shoptetLang).text;
//     // 	btn.innerText = btnText;
//     // }
//     if (title && newsLetterTitle) {
//       const titleText = newsLetterTitle.find(
//         item => item.language === shoptetLang
//       ).text
//       title.innerHTML = titleText
//     }

//     const newsletterImgUrl =
//       '/user/documents/upload/newDesign/photos/newsletter.jpg'
//     if (newsletterImgUrl) {
//       const imgDiv = document.createElement('div')
//       imgDiv.classList.add('img')
//       const img = document.createElement('img')

//       img.src = newsletterImgUrl
//       img.alt = 'Newsletter'
//       imgDiv.appendChild(img)
//       newsLeter.appendChild(imgDiv)
//     }
//   }
// }
// handleNewsletter()

window.hodnoceniUrl = [
  { language: "cs", url: "/hodnoceni-obchodu/" },
  { language: "en", url: "/store-rating/" },
  { language: "de", url: "/shop-bewertungen/" },
];

const url = hodnoceniUrl.find((item) => item.language === shoptetLang)?.url;
if (
  shoptetPage === "homepage" ||
  shoptetPage === "category" ||
  (shoptetPage === "productDetail" && url)
) {
  console.log(url);
  function createSec() {
    const section = document.createElement("section");
    section.className = "shop-review";
    return section;
  }

  const shopReview = createSec();

  let targetElement;
  if (shoptetPage === "homepage") {
    targetElement = document.querySelector(".body-banners");
  } else if (shoptetPage === "category" || shoptetPage === "productDetail") {
    targetElement = document.querySelector("#content-wrapper");
  }

  if (targetElement) {
    targetElement.parentNode.insertBefore(
      shopReview,
      targetElement.nextSibling
    );
  }

  const container = document.createElement("div");
  container.classList.add("container");
  shopReview.appendChild(container);

  const flexHolder = document.createElement("div");
  flexHolder.classList.add("flex-holder");
  container.appendChild(flexHolder);

  const h2 = document.createElement("h2");
  const langTitle = hodnoceniNadpis.find(
    (item) => item.language === shoptetLang
  );
  if (langTitle) {
    h2.innerHTML = langTitle.text;
  }
  const titleWrapper = document.createElement("div");
  titleWrapper.classList.add("title-wrapper");

  const votes = document.createElement("div");
  votes.classList.add("votes-wrap");

  const btn = document.createElement("a");
  btn.classList.add("btn", "btn-primary");
  btn.href = url;
  const langObject = recenzeBtnText.find(
    (item) => item.language === shoptetLang
  );
  if (langObject) {
    btn.innerHTML = langObject.text;
  }
  flexHolder.appendChild(titleWrapper);
  titleWrapper.appendChild(h2);
  flexHolder.appendChild(votes);
  flexHolder.appendChild(btn);

  if (url) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((data) => {
        const tempContainer = document.createElement("div");
        tempContainer.innerHTML = data;

        const newsItems = tempContainer.querySelectorAll(
          ".vote-wrap:not([data-testid='gridRatingReaction'])"
        );
        const firstThreeNewsItems = Array.from(newsItems).slice(0, 10);

        firstThreeNewsItems.forEach((item) => {
          const name = item.querySelector(".vote-name span").innerText;
          const desc = item.querySelector(".vote-content").innerText;
          const newItem = document.createElement("div");

          newItem.classList.add("vote-wrap");

          const starsContainer = document.createElement("span");
          starsContainer.classList.add("stars");

          const existingStars = item.querySelectorAll(".stars .star");
          existingStars.forEach((existingStar) => {
            const starClass = existingStar.classList.contains("star-on")
              ? "star-on"
              : "star-off";
            const newStar = document.createElement("span");
            newStar.classList.add("star", starClass);
            starsContainer.appendChild(newStar);
          });

          newItem.innerHTML = `
                        <div class="vote-header">
                            <span class="vote-rating">
                                ${starsContainer.outerHTML}
                            </span>
                            <span class="vote-summary">
                                <span class="vote-name"><span>${name}</span></span>
                            </span>
                        </div>
                        <div class="vote-content" data-testid="textRating">${desc}</div>
                    `;

          votes.appendChild(newItem);
        });

        swiperize({
          containers: ".votes-wrap",
          slide: ":scope > .vote-wrap",
          customOptions: {
            fullscreen: false,
            infinity: true,
            dots: true,
            arrows: true,
            scrollbar: false,
            lazyPrevNext: true,
            swiperWrapper: true,
          },
          swiperOptions: {
            direction: "horizontal",
            speed: 800,
            spaceBetween: 20,
            slidesPerView: 1.2,
            breakpoints: {
              1023: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
              660: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
            },
          },
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

if (shoptetPage === "category") {
  moveElement(".safe-packaging", ["#content-wrapper"]);
  moveElement(".about-us", [".shop-review", "#content-wrapper"]);
}
if (shoptetPage === "productDetail") {
  moveElement(".safe-packaging", ["#content-wrapper"]);
  moveElement(".about-us", [".shop-review", "#content-wrapper"]);

}
